<template>
  <div class="result">
    <div class="header">
      <a class="logo" href="javascript:;"  @click="$router.push('/')">
        <img src="../assets/img/logo.svg" alt="">
      </a>
    </div>
    <div class="content">
      <div class="error" v-if='!this.success'>{{msg}}</div>
      <div class="success" v-if='this.success'>{{msg}}</div>
      <div class="back">页面将在 <span class="num">{{time}}</span> 秒后自动跳转，如果不想等待请点击 <span class="link" @click="goBack()">这里</span> 跳转</div>
    </div>
    <detail-footer></detail-footer>
  </div>
</template>

<script>
import DetailFooter from './_footer'

export default {
  components: {
    DetailFooter
  },
  data () {
    return {
      route:'',
      msg:'',
      time:3,
      success:true
    }
  },
  mounted() {
    this.route = this.$route.query.route;
    this.showMsg();
    this.timeReturn(this.time);
  },
  methods: {
    timeReturn(time){
      let $this = this
      if(time == 0){
        $this.$router.go(-1);
      }else{
        $this.time--
        setTimeout(function(){ 
          $this.timeReturn($this.time);
        },1000) 
      } 
    },
    showMsg(){
      if(this.route == "user"){
        this.$axios.post('/api/web/phone/personal-center/modify-psw',{password:this.$route.query.password}).then(res => {
          if(res.code != 200){
            this.success = false;
            this.msg='操作失败！重置密码失败';
          }else{
            this.success = true;
            this.msg='操作成功！重置密码成功，密码为'+this.$route.query.password;
          }
        })
      }else if(this.route == "industry-report-detail"){

        this.$axios.post('/api/web/phone/personal-center/download',{fileId:this.$route.query.fileId}).then((res)=>{
          console.log(res.data.downloadTag)
          if(!res.data.downloadTag){
            this.success = false;
            this.msg = res.data.message;
          }else{
            document.location = res.data.fileUrl;
            this.success = true;
            this.msg='下载成功';
          }

        });
      }
    },
    goBack(){
      this.$router.go(-1);
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '../assets/sass/global.scss';

  .result {
    background: #F5F5F5;
    min-height: 100vh;
    box-sizing:border-box;
    position: relative;
  }
  .pl-75{
    padding-left: 75px;
  }
  .mt-15{
    margin-top: 15px;
  }
  .header{
    height: 54px;
    background: #fff;
    border-bottom: 2px solid #f5f5f5;
    top: 0;
    left: 0;
    right: 0;
    position:fixed;
    z-index: 99;
    .logo{
      display: inline-block;
      // width: 155px;
      // height: 24px;
      position: absolute;
      top: 15px;
      left: 15px;
      img{
        height: 35px;
      }
    }
  }
  .content {
    min-height: calc(100vh - 66px);
    box-sizing: border-box;
    padding-top: 54px;
    .error{
      padding:74px 15px 38px 15px ; 

      height:22px;
      font-size:16px;
      color:#FD6262;
      line-height:22px;
    }
    .success{
      padding:74px 15px 38px 15px ; 

      height:22px;
      font-size:16px;
      color:#64A9FF;
      line-height:22px;
    }
    .back{
      height:18px;
      font-size:13px;
      color:rgba(102,102,102,1);
      line-height:18px;
      .num{
        color: #64A9FF;
        font-size: 18px;
      }
      .link{
        color: #64A9FF;
        font-size: 14px;
        text-decoration: underline;
      }
    }
  }
  .footer{
    box-sizing: border-box;
    height: 66px;
    background: #0C324C;
    padding: 12px 0;
    li{
      color: #fff;
      font-size: 13px;
      height: 18px;
      span{
        width:6px;
        display: inline-block;
        text-align: center;
      }
      a{
        color: #fff;
      }
    }
    .footer_tip{
      margin-top: 7px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/result.vue